"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullableW = exports.DateFromISOString = exports.WorkflowTypeDec = exports.PriorityDec = void 0;
const D = __importStar(require("io-ts/lib/Decoder"));
const function_1 = require("fp-ts/function");
exports.PriorityDec = D.literal('LOW', 'MEDIUM', 'HIGH');
exports.WorkflowTypeDec = D.literal('CREATIVE_WORK_TAGGING');
exports.DateFromISOString = (0, function_1.pipe)(D.string, D.parse(s => {
    const d = new Date(s);
    return isNaN(d.getTime()) ? D.failure(s, 'ISO Date string') : D.success(d);
}));
/**
 * Widen undefined values to null
 */
const nullableW = (or) => ({
    decode: i => D.nullable(or).decode(i == null ? null : i),
});
exports.nullableW = nullableW;
//# sourceMappingURL=codecs.js.map